/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.utilsModule')

  /**
   * Directive to add the max length for any tag.
   */
  .directive('bulbMaxlength', ['$window', bulbMaxlength]);

function bulbMaxlength($window) {
  return {
    restrict: 'A',
    link(scope, element, attribute) {
      /**
       * Array of allowed keycodes when max limit is reached
       * 8 : Backspace, 17: ctrlKey, 37: LeftKey, 38: UpKey, 39: RightKey
       * 40: DownKey, 46: DeleteKey, 91: Left metaKey(in mac), 92: right metaKey(in mac)
       */
      const allowedKeyCodes = [8, 17, 37, 38, 39, 40, 46, 91, 92];
      const maxLength = attribute.bulbMaxlength;
      const elem = document.querySelectorAll('*[bulb-maxlength]');
      const registeredEvents = ['keydown', 'paste'];

      Array.from(elem).forEach((element) => {
        registeredEvents.forEach((keyboardEvent) => {
          element.addEventListener(keyboardEvent, maxlengthEventHandler);
        });
      });

      /**
       * callback for 'keydown', 'paste' events
       * @param {any} event
       */
      function maxlengthEventHandler(event) {
        if (event.clipboardData) {
          if (event.clipboardData.getData('Text').length + this.textContent.length > maxLength) {
            event.preventDefault();
          }
        } else if (this.textContent.length >= maxLength && !allowedKeyCodes.includes(event.keyCode)) {
          event.preventDefault();
        }
      }

      /**
       * Remove the registered events.
       */
      scope.$on('$destroy', () => {
        $window.removeEventListener('keydown', maxlengthEventHandler);
        $window.removeEventListener('paste', maxlengthEventHandler);
      });
    },
  };
}
